﻿import Api from "../../../../shared/Api";


class ShowcaseOrderApi {
    static getShowcaseOrder(orderId: number): Promise<any> {
        return new Api().get('/views/showcaseorder/' + orderId);
    }

    static getProfileSettings(orderId: number): Promise<any> {
        return new Api().get('/views/showcaseorder/profileSettings/' + orderId)
    }
}
export default ShowcaseOrderApi;


